/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */

// import $ from 'jquery';
import mobileNav from './components/mobileNav';
import accessibleMenu from './components/accesibleMenu';
import headerBehaviour from './components/headerBehaviour';
import quoteForm from './components/quoteForm';
import scrollIt from './components/scrollIt';

mobileNav();
accessibleMenu();
quoteForm();

// Logo behaviour on page scroll
window.onscroll = function() {
  headerBehaviour();
};

document.addEventListener('DOMContentLoaded', function() {
  // remove type="" attribute in <style></style> and <script></script>
  var scriptJsArr = Array.from(document.querySelectorAll('script'));
  var styleCssArr = Array.from(document.querySelectorAll('style'));

  scriptJsArr.forEach(function(scriptJs) {
    scriptJs.removeAttribute('type');
  });

  styleCssArr.forEach(function(styleCss) {
    styleCss.removeAttribute('type');
  });

  // Add class .no-sidebar for full-width content
  var asideArea = document.querySelector('#sidebar');
  var contentArea = document.querySelector('#content');

  if (!asideArea) {
    if (contentArea !== null) {
      contentArea.classList.add('no-sidebar');
    }
  }

  // Scroll to element
  const navigationPageLinks = Array.from(document.querySelectorAll('.navigation-page a'));

  // Add class scoll-it to all navigation page link
  navigationPageLinks.forEach(function(navigationPageLink) {
    navigationPageLink.classList.add('scroll-it');
  });

  scrollIt();

  // Remove icon-scroll on page with navigation-page in content
  const iconScroll = document.querySelector('.icon-scroll');
  const navigationPage = document.querySelector('.navigation-page');

  if (document.body.offsetWidth > 1024) {
    navigationPage ? iconScroll.classList.toggle('hide-nav') : null;
  }
});
